import useAxios from '../../../library/axios'; 

import IBankUser, { IPasswordChange } from '../model/BankUser';

const _ = () => {

    const axios = useAxios();

    const saveBankUser = async (bankUser: IBankUser)  =>       
        await (await axios.post('/crm/bankUser/save', bankUser)).data;

    const getBankUser = async (userID  : number )  => {        
      const {data} = (await axios.get(`/crm/bankUser/getBankUser/${userID}`));
      return await data;
      }
    
    const getUsersList = async ()  => {
        const {data} = (await axios.get('/crm/bankUser/getUsersList'));
        return await data;
      }

    const updatePassword = async (passwordChange: IPasswordChange) => 
        await (await axios.post('/crm/bankUser/updatePassword', passwordChange)).data;

    const getDashboard = async ()  => {
        const {data} = (await axios.get('/crm/bankUser/getDashboard'));
        return await data;
    }

    return {
        saveBankUser,
        getBankUser,
        updatePassword,

        getUsersList,
        getDashboard   
    } 
}

export default _;